import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "audit-trail-modern" }
const _hoisted_2 = { class: "audit-header" }
const _hoisted_3 = { class: "audit-header-left" }
const _hoisted_4 = { class: "audit-title" }
const _hoisted_5 = {
  key: 0,
  class: "audit-stats"
}
const _hoisted_6 = { class: "stat-badge" }
const _hoisted_7 = {
  key: 0,
  class: "stat-badge filtered"
}
const _hoisted_8 = { class: "audit-header-right" }
const _hoisted_9 = {
  key: 0,
  class: "audit-filters"
}
const _hoisted_10 = { class: "filters-grid" }
const _hoisted_11 = { class: "filter-item" }
const _hoisted_12 = { value: "" }
const _hoisted_13 = { value: "CREATED" }
const _hoisted_14 = { value: "UPDATED" }
const _hoisted_15 = { value: "DELETED" }
const _hoisted_16 = { value: "CLOSED" }
const _hoisted_17 = { value: "REOPENED" }
const _hoisted_18 = { value: "UPLOADED" }
const _hoisted_19 = { value: "UPLOADED" }
const _hoisted_20 = { class: "filter-item" }
const _hoisted_21 = { value: "" }
const _hoisted_22 = { value: "PROJECT" }
const _hoisted_23 = { value: "PROJECT_PHASE" }
const _hoisted_24 = { value: "PROJECT_TASK" }
const _hoisted_25 = { value: "PROJECT_ISSUE" }
const _hoisted_26 = { value: "PROJECT_DOCUMENT" }
const _hoisted_27 = { value: "PROJECT_PHOTO" }
const _hoisted_28 = { value: "PROJECT_DESIGN" }
const _hoisted_29 = { value: "PROJECT_ACCESS" }
const _hoisted_30 = { value: "PROJECT_INTERVENANT" }
const _hoisted_31 = { value: "PROJECT_NOTE" }
const _hoisted_32 = { value: "PROJECT_FINANCE" }
const _hoisted_33 = { value: "PROJECT_TRANSACTION" }
const _hoisted_34 = { value: "PROJECT_NOTIFICATION" }
const _hoisted_35 = { value: "PROJECT_DOCUMENT_ANNOTATION" }
const _hoisted_36 = { value: "PROJECT_ISSUE_PHOTO" }
const _hoisted_37 = { value: "PROVISIONING_REQUEST" }
const _hoisted_38 = {
  key: 0,
  class: "state-container"
}
const _hoisted_39 = { class: "loading-state" }
const _hoisted_40 = {
  key: 1,
  class: "state-container"
}
const _hoisted_41 = { class: "error-state" }
const _hoisted_42 = {
  key: 2,
  class: "state-container"
}
const _hoisted_43 = { class: "empty-state" }
const _hoisted_44 = {
  key: 3,
  class: "audit-table-container"
}
const _hoisted_45 = { class: "audit-table-wrapper" }
const _hoisted_46 = { class: "audit-table" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "col-timestamp" }
const _hoisted_49 = { class: "timestamp-cell" }
const _hoisted_50 = ["title"]
const _hoisted_51 = { class: "time-exact" }
const _hoisted_52 = { class: "col-action" }
const _hoisted_53 = { class: "action-cell" }
const _hoisted_54 = { class: "action-label" }
const _hoisted_55 = { class: "col-entity" }
const _hoisted_56 = { class: "entity-cell" }
const _hoisted_57 = { class: "entity-type" }
const _hoisted_58 = { class: "entity-id" }
const _hoisted_59 = { class: "col-user" }
const _hoisted_60 = { class: "user-cell" }
const _hoisted_61 = { class: "user-avatar" }
const _hoisted_62 = { class: "user-name" }
const _hoisted_63 = { class: "col-description" }
const _hoisted_64 = { class: "description-cell" }
const _hoisted_65 = { class: "col-changes" }
const _hoisted_66 = { class: "changes-cell" }
const _hoisted_67 = {
  key: 0,
  class: "changes-badge"
}
const _hoisted_68 = {
  key: 1,
  class: "no-changes"
}
const _hoisted_69 = { class: "col-actions" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = {
  key: 0,
  class: "details-row"
}
const _hoisted_72 = { colspan: "7" }
const _hoisted_73 = { class: "details-panel" }
const _hoisted_74 = {
  key: 0,
  class: "details-section"
}
const _hoisted_75 = { class: "changes-grid" }
const _hoisted_76 = { class: "change-field" }
const _hoisted_77 = { class: "change-values" }
const _hoisted_78 = { class: "value-box old-value" }
const _hoisted_79 = { class: "value-content" }
const _hoisted_80 = { class: "value-box new-value" }
const _hoisted_81 = { class: "value-content" }
const _hoisted_82 = {
  key: 1,
  class: "details-section"
}
const _hoisted_83 = { class: "reason-box" }
const _hoisted_84 = {
  key: 2,
  class: "details-section"
}
const _hoisted_85 = { class: "tech-details" }
const _hoisted_86 = {
  key: 0,
  class: "tech-item"
}
const _hoisted_87 = {
  key: 1,
  class: "tech-item"
}
const _hoisted_88 = { class: "pagination-container" }
const _hoisted_89 = { class: "pagination-info" }
const _hoisted_90 = { class: "pagination-text" }
const _hoisted_91 = { class: "pagination-controls" }
const _hoisted_92 = ["disabled"]
const _hoisted_93 = ["disabled"]
const _hoisted_94 = { class: "page-numbers" }
const _hoisted_95 = ["onClick", "disabled"]
const _hoisted_96 = ["disabled"]
const _hoisted_97 = ["disabled"]
const _hoisted_98 = { class: "pagination-size" }

import { ref, computed, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useNotifications } from '@/composables/useNotifications'
import projectService from '@/services/project.service'
import type { 
  ProjectAuditLogResponseDto, 
  ProjectAuditLogQueryParams
} from '@/types/project/audit'

interface Props {
  projectId: number
  showFilters?: boolean
  pageSize?: number
}

interface ChangeData {
  field: string
  beforeValue: any
  afterValue: any
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectAuditTrail',
  props: {
    projectId: {},
    showFilters: { type: Boolean, default: false },
    pageSize: { default: 50 }
  },
  setup(__props: any) {

// @ts-ignore
const props = __props

const { t } = useI18n()
const { notifyError } = useNotifications()

// State
const loading = ref(false)
const error = ref<string | null>(null)
const allAuditLogs = ref<ProjectAuditLogResponseDto[]>([]) // Store all logs
const currentPage = ref(0)
const expandedDetails = ref(new Set<number>())
const showFiltersPanel = ref(props.showFilters)

// Filters
const filters = ref({
  action: '',
  entityType: '',
  size: props.pageSize
})

// Computed - filtered and paginated logs
const filteredAuditLogs = computed(() => {
  let filtered = allAuditLogs.value

  // Apply action filter
  if (filters.value.action) {
    filtered = filtered.filter((log: ProjectAuditLogResponseDto) => log.action === filters.value.action)
  }

  // Apply entity type filter
  if (filters.value.entityType) {
    filtered = filtered.filter((log: ProjectAuditLogResponseDto) => log.entityType === filters.value.entityType)
  }

  return filtered
})

const totalElements = computed(() => filteredAuditLogs.value.length)

const totalPages = computed(() => Math.ceil(filteredAuditLogs.value.length / filters.value.size))

const auditLogs = computed(() => {
  const start = currentPage.value * filters.value.size
  const end = start + filters.value.size
  return filteredAuditLogs.value.slice(start, end)
})

const hasNextPage = computed(() => currentPage.value < totalPages.value - 1)

const visiblePages = computed(() => {
  const pages: (number | string)[] = []
  const total = totalPages.value
  const current = currentPage.value
  const maxVisible = 7 // Maximum number of page buttons to show

  if (total <= maxVisible) {
    // Show all pages if total is small
    for (let i = 0; i < total; i++) {
      pages.push(i)
    }
  } else {
    // Always show first page
    pages.push(0)

    if (current <= 3) {
      // Near the beginning
      for (let i = 1; i <= 4; i++) {
        pages.push(i)
      }
      pages.push('...')
      pages.push(total - 1)
    } else if (current >= total - 4) {
      // Near the end
      pages.push('...')
      for (let i = total - 5; i < total - 1; i++) {
        pages.push(i)
      }
      pages.push(total - 1)
    } else {
      // In the middle
      pages.push('...')
      for (let i = current - 1; i <= current + 1; i++) {
        pages.push(i)
      }
      pages.push('...')
      pages.push(total - 1)
    }
  }

  return pages
})

// Methods
const toggleFilters = () => {
  showFiltersPanel.value = !showFiltersPanel.value
}

const clearFilters = () => {
  filters.value = {
    action: '',
    entityType: '',
    size: props.pageSize
  }
  currentPage.value = 0
}

const goToPage = (page: number) => {
  if (page >= 0 && page < totalPages.value && page !== currentPage.value) {
    currentPage.value = page
    // Scroll to top of table
    const tableContainer = document.querySelector('.audit-table-wrapper')
    if (tableContainer) {
      tableContainer.scrollTop = 0
    }
  }
}

const onPageSizeChange = () => {
  currentPage.value = 0
}

const loadAuditLogs = async () => {
  loading.value = true
  error.value = null

  try {
    // Load all logs without pagination (or with a large page size)
    const params = {
      page: 0,
      size: 10000, // Load all logs at once
      sort: 'timestamp',
      direction: 'DESC' as 'ASC' | 'DESC'
    }

    const response = await projectService.getProjectAuditLogs(props.projectId, params)
    
    if (response) {
      const newLogs = response.content.map(log => ({
        ...log,
        formattedTimestamp: formatTimestamp(log.timestamp),
        actionDescription: getActionDescription(log.action, log.entityType),
        actionIcon: getActionIcon(log.action),
        actionColor: getActionColor(log.action),
        canViewSensitiveInfo: canViewSensitiveInfo()
      }))

      allAuditLogs.value = newLogs
    }
  } catch (err: any) {
    error.value = err.message || t('projects.audit.loadError')
    notifyError(error.value)
  } finally {
    loading.value = false
  }
}

const onFilterChange = () => {
  // Reset to first page when filters change
  currentPage.value = 0
}

const toggleDetails = (logId: number) => {
  if (expandedDetails.value.has(logId)) {
    expandedDetails.value.delete(logId)
  } else {
    expandedDetails.value.add(logId)
  }
}

const hasDetails = (log: ProjectAuditLogResponseDto): boolean => {
  return !!(log.beforeValues || log.afterValues || log.changedFields || log.changeReason)
}

// Utility functions
const formatTimestamp = (timestamp: string): string => {
  const date = new Date(timestamp)
  const now = new Date()
  const diffInMinutes = Math.floor((now.getTime() - date.getTime()) / (1000 * 60))

  if (diffInMinutes < 1) return t('common.time.justNow')
  if (diffInMinutes < 60) return t('common.time.minutesAgo', { count: diffInMinutes })
  
  const diffInHours = Math.floor(diffInMinutes / 60)
  if (diffInHours < 24) return t('common.time.hoursAgo', { count: diffInHours })
  
  const diffInDays = Math.floor(diffInHours / 24)
  if (diffInDays < 7) return t('common.time.daysAgo', { count: diffInDays })
  
  return date.toLocaleDateString()
}

const formatTime = (timestamp: string): string => {
  return new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
}

const formatFullTimestamp = (timestamp: string): string => {
  return new Date(timestamp).toLocaleString()
}

const formatUserAgent = (userAgent: string): string => {
  // Simple user agent formatting - extract browser name
  if (userAgent.includes('Chrome')) return 'Chrome'
  if (userAgent.includes('Firefox')) return 'Firefox'
  if (userAgent.includes('Safari')) return 'Safari'
  if (userAgent.includes('Edge')) return 'Edge'
  return 'Browser'
}

const getUserInitials = (userName: string): string => {
  return userName
    .split(' ')
    .map(word => word[0])
    .join('')
    .toUpperCase()
    .substring(0, 2)
}

const formatActionLabel = (action: string): string => {
  return action
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, c => c.toUpperCase())
}

const getActionDescription = (action: string, entityType: string): string => {
  const key = `projects.audit.descriptions.${action.toLowerCase()}`
  return t(key, { entity: getEntityLabel(entityType) })
}

const getActionIcon = (action: string): string => {
  const iconMap: Record<string, string> = {
    CREATED: '✨',
    UPDATED: '✏️',
    DELETED: '🗑️',
    CLOSED: '🔒',
    REOPENED: '🔓',
    DOCUMENT_UPLOADED: '📄',
    PHOTO_UPLOADED: '📷',
    DESIGN_UPLOADED: '🎨',
    PHASE_CREATED: '📋',
    TASK_CREATED: '✅',
    ISSUE_CREATED: '⚠️',
    ACCESS_GRANTED: '👥',
    ACCESS_REVOKED: '🚫',
    NOTE_CREATED: '📝',
    PAYMENT_RECORDED: '💰',
    PAYMENT_VALIDATED: '💵'
  }
  return iconMap[action] || '📋'
}

const getActionColor = (action: string): string => {
  const colorMap: Record<string, string> = {
    CREATED: '#10b981',
    UPDATED: '#3b82f6',
    DELETED: '#ef4444',
    CLOSED: '#6b7280',
    REOPENED: '#8b5cf6',
    DOCUMENT_UPLOADED: '#06b6d4',
    PHOTO_UPLOADED: '#f59e0b',
    DESIGN_UPLOADED: '#ec4899',
    PHASE_CREATED: '#14b8a6',
    TASK_CREATED: '#84cc16',
    ISSUE_CREATED: '#f97316',
    ACCESS_GRANTED: '#22c55e',
    ACCESS_REVOKED: '#dc2626',
    NOTE_CREATED: '#6366f1',
    PAYMENT_RECORDED: '#059669',
    PAYMENT_VALIDATED: '#16a34a'
  }
  return colorMap[action] || '#6b7280'
}

const getActionClass = (action: string): string => {
  if (action.includes('CREATED') || action.includes('UPLOADED') || action.includes('GRANTED')) return 'success'
  if (action.includes('DELETED') || action.includes('REVOKED')) return 'danger'
  if (action.includes('UPDATED')) return 'info'
  if (action.includes('CLOSED')) return 'warning'
  return 'default'
}

const getEntityLabel = (entityType: string): string => {
  const labelMap: Record<string, string> = {
    PROJECT: t('projects.audit.entities.project'),
    PROJECT_PHASE: t('projects.audit.entities.phase'),
    PROJECT_TASK: t('projects.audit.entities.task'),
    PROJECT_ISSUE: t('projects.audit.entities.issue'),
    PROJECT_DOCUMENT: t('projects.audit.entities.document'),
    PROJECT_PHOTO: t('projects.audit.entities.photo'),
    PROJECT_DESIGN: t('projects.audit.entities.design'),
    PROJECT_ACCESS: t('projects.audit.entities.access'),
    PROJECT_INTERVENANT: t('projects.audit.entities.intervenant'),
    PROJECT_NOTE: t('projects.audit.entities.note'),
    PROJECT_FINANCE: t('projects.audit.entities.finance'),
    PROJECT_TRANSACTION: t('projects.audit.entities.transaction'),
    PROJECT_NOTIFICATION: t('projects.audit.entities.notification'),
    PROJECT_DOCUMENT_ANNOTATION: t('projects.audit.entities.documentAnnotation'),
    PROJECT_ISSUE_PHOTO: t('projects.audit.entities.issuePhoto'),
    PROVISIONING_REQUEST: t('projects.audit.entities.provisioningRequest')
  }
  return labelMap[entityType] || entityType
}

const canViewSensitiveInfo = (): boolean => {
  // This would check user permissions - simplified for now
  return false
}

// New utility functions for table display
const getChangesData = (log: ProjectAuditLogResponseDto): ChangeData[] => {
  const changes: ChangeData[] = []
  
  // If we have changed fields data, use it
  if (log.changedFields) {
    try {
      const changedFields = JSON.parse(log.changedFields)
      
      // Check if it's an object (expected format from backend)
      if (changedFields && typeof changedFields === 'object' && !Array.isArray(changedFields)) {
        Object.entries(changedFields).forEach(([fieldName, fieldData]: [string, any]) => {
          changes.push({
            field: fieldName,
            beforeValue: fieldData.oldValue,
            afterValue: fieldData.newValue
          })
        })
      }
      // Fallback: handle array format if backend returns it
      else if (Array.isArray(changedFields)) {
        changedFields.forEach((change: any) => {
          changes.push({
            field: change.fieldName || change.field,
            beforeValue: change.beforeValue || change.oldValue,
            afterValue: change.afterValue || change.newValue
          })
        })
      }
    } catch (e) {
      console.warn('Error parsing changedFields:', e, log.changedFields)
    }
  }
  
  // If no changed fields but we have before/after values, compare them
  if (changes.length === 0 && log.beforeValues && log.afterValues) {
    try {
      const before = JSON.parse(log.beforeValues)
      const after = JSON.parse(log.afterValues)
      
      // Compare all fields in the after object
      Object.keys(after).forEach(key => {
        if (before[key] !== after[key]) {
          changes.push({
            field: key,
            beforeValue: before[key],
            afterValue: after[key]
          })
        }
      })
      
      // Also check for removed fields (in before but not in after)
      Object.keys(before).forEach(key => {
        if (!(key in after) && before[key] !== null) {
          changes.push({
            field: key,
            beforeValue: before[key],
            afterValue: null
          })
        }
      })
    } catch (e) {
      console.warn('Error parsing before/after values:', e)
    }
  }
  
  return changes
}

const formatFieldName = (fieldName: string): string => {
  // Convert camelCase or snake_case to readable format
  return fieldName
    .replace(/([A-Z])/g, ' $1') // Add space before uppercase letters
    .replace(/_/g, ' ') // Replace underscores with spaces
    .replace(/^\w/, c => c.toUpperCase()) // Capitalize first letter
    .trim()
}

const formatDisplayValue = (value: any): string => {
  if (value === null || value === undefined) {
    return '—'
  }
  
  if (typeof value === 'boolean') {
    return value ? t('common.yes') : t('common.no')
  }
  
  // Check if it's an encrypted PII field (format: v0000001:base64...)
  if (typeof value === 'string' && value.match(/^v\d+:[A-Za-z0-9+/=]+$/)) {
    return '[Encrypted Data]'
  }
  
  // Check if it's a date string (ISO format)
  if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2})?/)) {
    try {
      const date = new Date(value)
      if (!isNaN(date.getTime())) {
        // If it includes time, show full datetime
        if (value.includes('T')) {
          return date.toLocaleString()
        }
        // Otherwise just the date
        return date.toLocaleDateString()
      }
    } catch (e) {
      // Not a valid date, continue
    }
  }
  
  if (typeof value === 'object') {
    // For dates
    if (value instanceof Date) {
      return value.toLocaleDateString()
    }
    // For arrays
    if (Array.isArray(value)) {
      return value.join(', ')
    }
    // For objects, show a summary
    return JSON.stringify(value)
  }
  
  // Format numbers with appropriate precision
  if (typeof value === 'number') {
    // If it's a decimal with more than 2 decimal places, format it
    if (value % 1 !== 0) {
      return value.toFixed(2)
    }
    return String(value)
  }
  
  return String(value)
}

// Watchers
watch(() => props.projectId, () => {
  if (props.projectId) {
    loadAuditLogs()
  }
})

// Lifecycle
onMounted(() => {
  if (props.projectId) {
    loadAuditLogs()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("i", { class: "pi pi-history" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('projects.audit.title')), 1)
        ]),
        (totalElements.value > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _cache[9] || (_cache[9] = _createElementVNode("i", { class: "pi pi-chart-line" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(totalElements.value) + " " + _toDisplayString(_ctx.$t('projects.audit.activities')), 1)
              ]),
              (filters.value.action || filters.value.entityType)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [...(_cache[10] || (_cache[10] = [
                    _createElementVNode("i", { class: "pi pi-filter" }, null, -1),
                    _createTextVNode(" Filtered ", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          onClick: toggleFilters,
          class: _normalizeClass(["filter-toggle-btn", { active: showFiltersPanel.value }])
        }, [
          _cache[11] || (_cache[11] = _createElementVNode("i", { class: "pi pi-filter" }, null, -1)),
          _cache[12] || (_cache[12] = _createElementVNode("span", null, "Filters", -1)),
          _createElementVNode("i", {
            class: _normalizeClass(["pi pi-chevron-down", { rotated: showFiltersPanel.value }])
          }, null, 2)
        ], 2),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (loadAuditLogs())),
          class: "refresh-btn"
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["pi pi-refresh", { spinning: loading.value }])
          }, null, 2)
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "slide-down" }, {
      default: _withCtx(() => [
        (showFiltersPanel.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", null, [
                    _cache[13] || (_cache[13] = _createElementVNode("i", { class: "pi pi-bolt" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('projects.audit.filterByAction')), 1)
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.action) = $event)),
                    onChange: onFilterChange,
                    class: "modern-select"
                  }, [
                    _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.$t('common.all')), 1),
                    _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.$t('projects.audit.actions.created')), 1),
                    _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.$t('projects.audit.actions.updated')), 1),
                    _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.$t('projects.audit.actions.deleted')), 1),
                    _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.$t('projects.audit.actions.closed')), 1),
                    _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.$t('projects.audit.actions.reopened')), 1),
                    _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.$t('projects.audit.actions.documentUploaded')), 1),
                    _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.$t('projects.audit.actions.photoUploaded')), 1)
                  ], 544), [
                    [_vModelSelect, filters.value.action]
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", null, [
                    _cache[14] || (_cache[14] = _createElementVNode("i", { class: "pi pi-box" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('projects.audit.filterByEntity')), 1)
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value.entityType) = $event)),
                    onChange: onFilterChange,
                    class: "modern-select"
                  }, [
                    _createElementVNode("option", _hoisted_21, _toDisplayString(_ctx.$t('common.all')), 1),
                    _createElementVNode("option", _hoisted_22, _toDisplayString(_ctx.$t('projects.audit.entities.project')), 1),
                    _createElementVNode("option", _hoisted_23, _toDisplayString(_ctx.$t('projects.audit.entities.phase')), 1),
                    _createElementVNode("option", _hoisted_24, _toDisplayString(_ctx.$t('projects.audit.entities.task')), 1),
                    _createElementVNode("option", _hoisted_25, _toDisplayString(_ctx.$t('projects.audit.entities.issue')), 1),
                    _createElementVNode("option", _hoisted_26, _toDisplayString(_ctx.$t('projects.audit.entities.document')), 1),
                    _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.$t('projects.audit.entities.photo')), 1),
                    _createElementVNode("option", _hoisted_28, _toDisplayString(_ctx.$t('projects.audit.entities.design')), 1),
                    _createElementVNode("option", _hoisted_29, _toDisplayString(_ctx.$t('projects.audit.entities.access')), 1),
                    _createElementVNode("option", _hoisted_30, _toDisplayString(_ctx.$t('projects.audit.entities.intervenant')), 1),
                    _createElementVNode("option", _hoisted_31, _toDisplayString(_ctx.$t('projects.audit.entities.note')), 1),
                    _createElementVNode("option", _hoisted_32, _toDisplayString(_ctx.$t('projects.audit.entities.finance')), 1),
                    _createElementVNode("option", _hoisted_33, _toDisplayString(_ctx.$t('projects.audit.entities.transaction')), 1),
                    _createElementVNode("option", _hoisted_34, _toDisplayString(_ctx.$t('projects.audit.entities.notification')), 1),
                    _createElementVNode("option", _hoisted_35, _toDisplayString(_ctx.$t('projects.audit.entities.documentAnnotation')), 1),
                    _createElementVNode("option", _hoisted_36, _toDisplayString(_ctx.$t('projects.audit.entities.issuePhoto')), 1),
                    _createElementVNode("option", _hoisted_37, _toDisplayString(_ctx.$t('projects.audit.entities.provisioningRequest')), 1)
                  ], 544), [
                    [_vModelSelect, filters.value.entityType]
                  ])
                ]),
                _createElementVNode("div", { class: "filter-item filter-actions" }, [
                  _createElementVNode("button", {
                    onClick: clearFilters,
                    class: "clear-filters-btn"
                  }, [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("i", { class: "pi pi-times" }, null, -1),
                    _createTextVNode(" Clear Filters ", -1)
                  ]))])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "spinner" }, null, -1)),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('projects.audit.loading')), 1)
          ])
        ]))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _cache[18] || (_cache[18] = _createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1)),
              _cache[19] || (_cache[19] = _createElementVNode("h3", null, "Error Loading Audit Trail", -1)),
              _createElementVNode("p", null, _toDisplayString(error.value), 1),
              _createElementVNode("button", {
                onClick: loadAuditLogs,
                class: "retry-btn"
              }, [
                _cache[17] || (_cache[17] = _createElementVNode("i", { class: "pi pi-refresh" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.retry')), 1)
              ])
            ])
          ]))
        : (auditLogs.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _cache[20] || (_cache[20] = _createElementVNode("i", { class: "pi pi-inbox" }, null, -1)),
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('projects.audit.noActivities')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('projects.audit.noActivitiesDescription')), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("table", _hoisted_46, [
                  _cache[32] || (_cache[32] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { class: "col-timestamp" }, [
                        _createElementVNode("i", { class: "pi pi-clock" }),
                        _createTextVNode(" Time ")
                      ]),
                      _createElementVNode("th", { class: "col-action" }, [
                        _createElementVNode("i", { class: "pi pi-bolt" }),
                        _createTextVNode(" Action ")
                      ]),
                      _createElementVNode("th", { class: "col-entity" }, [
                        _createElementVNode("i", { class: "pi pi-box" }),
                        _createTextVNode(" Entity ")
                      ]),
                      _createElementVNode("th", { class: "col-user" }, [
                        _createElementVNode("i", { class: "pi pi-user" }),
                        _createTextVNode(" User ")
                      ]),
                      _createElementVNode("th", { class: "col-description" }, [
                        _createElementVNode("i", { class: "pi pi-info-circle" }),
                        _createTextVNode(" Description ")
                      ]),
                      _createElementVNode("th", { class: "col-changes" }, [
                        _createElementVNode("i", { class: "pi pi-file-edit" }),
                        _createTextVNode(" Changes ")
                      ]),
                      _createElementVNode("th", { class: "col-actions" })
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(auditLogs.value, (log) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: log.id
                      }, [
                        _createElementVNode("tr", {
                          class: _normalizeClass(["audit-row", { 
                  'row-expanded': expandedDetails.value.has(log.id),
                  [`row-${getActionClass(log.action)}`]: true 
                }]),
                          onClick: ($event: any) => (hasDetails(log) ? toggleDetails(log.id) : null)
                        }, [
                          _createElementVNode("td", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("span", {
                                class: "time-relative",
                                title: formatFullTimestamp(log.timestamp)
                              }, _toDisplayString(log.formattedTimestamp), 9, _hoisted_50),
                              _createElementVNode("span", _hoisted_51, _toDisplayString(formatTime(log.timestamp)), 1)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("span", {
                                class: "action-icon",
                                style: _normalizeStyle({ backgroundColor: log.actionColor })
                              }, _toDisplayString(log.actionIcon), 5),
                              _createElementVNode("span", _hoisted_54, _toDisplayString(formatActionLabel(log.action)), 1)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("span", _hoisted_57, _toDisplayString(getEntityLabel(log.entityType)), 1),
                              _createElementVNode("span", _hoisted_58, "#" + _toDisplayString(log.entityId), 1)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_59, [
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, _toDisplayString(getUserInitials(log.userName || 'User ' + log.userId)), 1),
                              _createElementVNode("span", _hoisted_62, _toDisplayString(log.userName || 'User ' + log.userId), 1)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_63, [
                            _createElementVNode("div", _hoisted_64, _toDisplayString(log.description), 1)
                          ]),
                          _createElementVNode("td", _hoisted_65, [
                            _createElementVNode("div", _hoisted_66, [
                              (log.changeCount > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(log.changeCount), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_68, "—"))
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_69, [
                            (hasDetails(log))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["expand-btn", { expanded: expandedDetails.value.has(log.id) }]),
                                  onClick: _withModifiers(($event: any) => (toggleDetails(log.id)), ["stop"])
                                }, [...(_cache[21] || (_cache[21] = [
                                  _createElementVNode("i", { class: "pi pi-chevron-down" }, null, -1)
                                ]))], 10, _hoisted_70))
                              : _createCommentVNode("", true)
                          ])
                        ], 10, _hoisted_47),
                        (expandedDetails.value.has(log.id))
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_71, [
                              _createElementVNode("td", _hoisted_72, [
                                _createElementVNode("div", _hoisted_73, [
                                  (getChangesData(log).length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                        _cache[25] || (_cache[25] = _createElementVNode("h4", { class: "section-title" }, [
                                          _createElementVNode("i", { class: "pi pi-file-edit" }),
                                          _createTextVNode(" Field Changes ")
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_75, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getChangesData(log), (change) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: change.field,
                                              class: "change-item"
                                            }, [
                                              _createElementVNode("div", _hoisted_76, _toDisplayString(formatFieldName(change.field)), 1),
                                              _createElementVNode("div", _hoisted_77, [
                                                _createElementVNode("div", _hoisted_78, [
                                                  _cache[22] || (_cache[22] = _createElementVNode("span", { class: "value-label" }, "Before", -1)),
                                                  _createElementVNode("span", _hoisted_79, _toDisplayString(formatDisplayValue(change.beforeValue) || '—'), 1)
                                                ]),
                                                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "arrow-divider" }, [
                                                  _createElementVNode("i", { class: "pi pi-arrow-right" })
                                                ], -1)),
                                                _createElementVNode("div", _hoisted_80, [
                                                  _cache[23] || (_cache[23] = _createElementVNode("span", { class: "value-label" }, "After", -1)),
                                                  _createElementVNode("span", _hoisted_81, _toDisplayString(formatDisplayValue(change.afterValue) || '—'), 1)
                                                ])
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (log.changeReason)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                        _cache[26] || (_cache[26] = _createElementVNode("h4", { class: "section-title" }, [
                                          _createElementVNode("i", { class: "pi pi-comment" }),
                                          _createTextVNode(" Change Reason ")
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_83, _toDisplayString(log.changeReason), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (log.canViewSensitiveInfo && (log.ipAddress || log.userAgent))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                        _cache[31] || (_cache[31] = _createElementVNode("h4", { class: "section-title" }, [
                                          _createElementVNode("i", { class: "pi pi-shield" }),
                                          _createTextVNode(" Technical Details ")
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_85, [
                                          (log.ipAddress)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_86, [
                                                _cache[27] || (_cache[27] = _createElementVNode("i", { class: "pi pi-map-marker" }, null, -1)),
                                                _cache[28] || (_cache[28] = _createElementVNode("strong", null, "IP:", -1)),
                                                _createTextVNode(" " + _toDisplayString(log.ipAddress), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (log.userAgent)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_87, [
                                                _cache[29] || (_cache[29] = _createElementVNode("i", { class: "pi pi-desktop" }, null, -1)),
                                                _cache[30] || (_cache[30] = _createElementVNode("strong", null, "Browser:", -1)),
                                                _createTextVNode(" " + _toDisplayString(formatUserAgent(log.userAgent)), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("span", _hoisted_90, " Showing " + _toDisplayString(((currentPage.value) * filters.value.size) + 1) + " to " + _toDisplayString(Math.min((currentPage.value + 1) * filters.value.size, totalElements.value)) + " of " + _toDisplayString(totalElements.value) + " activities ", 1)
                ]),
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (goToPage(0))),
                    disabled: currentPage.value === 0 || loading.value,
                    class: "pagination-btn",
                    title: "First page"
                  }, [...(_cache[33] || (_cache[33] = [
                    _createElementVNode("i", { class: "pi pi-angle-double-left" }, null, -1)
                  ]))], 8, _hoisted_92),
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (goToPage(currentPage.value - 1))),
                    disabled: currentPage.value === 0 || loading.value,
                    class: "pagination-btn",
                    title: "Previous page"
                  }, [...(_cache[34] || (_cache[34] = [
                    _createElementVNode("i", { class: "pi pi-angle-left" }, null, -1)
                  ]))], 8, _hoisted_93),
                  _createElementVNode("div", _hoisted_94, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (page) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: page,
                        onClick: ($event: any) => (page !== '...' ? goToPage(page) : null),
                        class: _normalizeClass(['page-btn', { 
                active: page === currentPage.value, 
                ellipsis: page === '...' 
              }]),
                        disabled: page === '...' || loading.value
                      }, _toDisplayString(page === '...' ? '...' : page + 1), 11, _hoisted_95))
                    }), 128))
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (goToPage(currentPage.value + 1))),
                    disabled: !hasNextPage.value || loading.value,
                    class: "pagination-btn",
                    title: "Next page"
                  }, [...(_cache[35] || (_cache[35] = [
                    _createElementVNode("i", { class: "pi pi-angle-right" }, null, -1)
                  ]))], 8, _hoisted_96),
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (goToPage(totalPages.value - 1))),
                    disabled: currentPage.value === totalPages.value - 1 || loading.value,
                    class: "pagination-btn",
                    title: "Last page"
                  }, [...(_cache[36] || (_cache[36] = [
                    _createElementVNode("i", { class: "pi pi-angle-double-right" }, null, -1)
                  ]))], 8, _hoisted_97)
                ]),
                _createElementVNode("div", _hoisted_98, [
                  _cache[38] || (_cache[38] = _createElementVNode("label", { for: "page-size" }, "Per page:", -1)),
                  _withDirectives(_createElementVNode("select", {
                    id: "page-size",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.value.size) = $event)),
                    onChange: onPageSizeChange,
                    class: "page-size-select"
                  }, [...(_cache[37] || (_cache[37] = [
                    _createElementVNode("option", { value: 10 }, "10", -1),
                    _createElementVNode("option", { value: 20 }, "20", -1),
                    _createElementVNode("option", { value: 50 }, "50", -1),
                    _createElementVNode("option", { value: 100 }, "100", -1)
                  ]))], 544), [
                    [_vModelSelect, filters.value.size]
                  ])
                ])
              ])
            ]))
  ]))
}
}

})